import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerKeyValueAll: [],
  insurerKeyValue: {},
  selectedCategory: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "keyName",
  sortOrder: "asc",
};

const insurerKeyValueSlice = createSlice({
  name: "insurerKeyValue",
  initialState,
  reducers: {
    setInsurerKeyValueAll: (state, action) => {
      state.insurerKeyValueAll = action.payload;
    },
    setInsurerKeyValue: (state, action) => {
      state.insurerKeyValue = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
  },
});

export const {
  setInsurerKeyValueAll,
  setInsurerKeyValue,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
  setSelectedCategory,
} = insurerKeyValueSlice.actions;

export default insurerKeyValueSlice.reducer;
